// extracted by mini-css-extract-plugin
module.exports = {"Container":"Layout_Container__i0CZr","MainColumn":"Layout_MainColumn__3KNHG","Canvas":"Layout_Canvas__l5nAD"};